import {
    headerColumnTypes,
    ITableHeaderColumn,
    sortDirections,
} from '../../types/lists/listTypes';
import { TagColor } from '../../muiComponents/Tag';
import { IStopSaleDetailState } from '../../types/stopSale/stopSalesTypes';

export const stopSalesTableColumns: ITableHeaderColumn[] = [
    {
        id: 'Enabled',
        labelText: 'enabled',
        titleText: 'enabled',
    },
    {
        id: 'SupplierHotel/Name',
        labelText: 'hotel',
        titleText: 'hotel',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotel/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'SupplierHotelRoomType/Name',
        labelText: 'room',
        titleText: 'room',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotelRoomType/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'SupplierHotelRatePlan/Name',
        labelText: 'rate_plan',
        titleText: 'rate_plan',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotelRatePlan/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'SupplierHotelMealPlan/Name',
        labelText: 'meal_plan',
        titleText: 'meal_plan',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotelMealPlan/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },

    {
        id: 'FromDate',
        labelText: 'dates',
        titleText: 'dates',
    },
];

export const STOP_SALES_DATE_TAG_COLOR: Record<string, TagColor> = {
    old: 'cyan',
    current: 'green',
    upcoming: 'purple',
};

export const STOP_SALES_INITIAL_STATE: IStopSaleDetailState = {
    Id: '',
    Enabled: true,
    FromDate: null,
    ToDate: null,
    IdSupplierHotel: 0,
    IdSupplierHotelRoomType: 0,
    IdSupplierHotelMealPlan: 0,
    IdSupplierHotelRatePlan: 0,
};

export const STOP_SALES_VALIDATION_INITIAL_STATE = {
    isValidated: false,
    IdSupplierHotel: '',
    FromToDate: '',
    FromDate: '',
    ToDate: '',
};
